<script setup lang="ts">
import { RadioGroupItem, RadioGroupRoot } from 'radix-vue'

const value = defineModel<string | number | null>()

withDefaults(
  defineProps<{
    list: (string | number | null)[]
    itemClass?: string
  }>(),
  {
    list: () => []
  }
)
</script>

<template>
  <radio-group-root
    class="flex w-full flex-row gap-1 p-[6px] bg-4 rounded-lg"
    default-value="default"
    orientation="horizontal"
    v-model="value"
  >
    <radio-group-item
      v-for="item in list"
      class="w-[100px] h-[26px] px-2 flex items-center justify-center bg-menu-item-bg text-secondary text-[14px] leading-4 border-none rounded-full font-normal whitespace-nowrap aria-checked:bg-text-inactive aria-checked:text-white"
      :class="itemClass"
      :value="item"
      :key="item"
    >
      <slot name="item-label" :item="item">{{ item }}</slot>
    </radio-group-item>
  </radio-group-root>
</template>

<style scoped></style>
